import styled from 'styled-components'
import colors from 'globals/colors'

interface MobileMailWrapperProps {
  selected: boolean
}

export const MobileMailWrapper = styled.div<MobileMailWrapperProps>`
  padding: 20px 12px;
  margin-bottom: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  
  ${(props) => props.selected && `
    background-color: ${colors.footerColor};
  `};
`

export const MobileMailDetails = styled.div`
  margin-left: 18px;
  flex: 1;
`

export const MobileMailRef = styled.span`
  line-height: 22px;
  font-weight: bold;
`

export const MobileMailType = styled.span`
  color: ${colors.steelGrey};
  margin-left: 18px;
`

export const MobileMailProcess = styled.div`
  line-height: 19px;
  margin-top: 10px;
`
